<template>
	<RouteOptimizerDialog v-model="routeOptimizer.open" :overlay-target="overlayTarget" :context="routeOptimizer.context" />
</template>

<script setup>
import { inject } from 'vue';
import { useWindowEventDialog } from '@/composables/useWindowEventDialog';
import RouteOptimizerDialog from './RouteOptimizerDialog.vue';

const overlayTarget = inject('overlayTarget', null);

const routeOptimizer = useWindowEventDialog('open-vue-route-optimizer');
</script>
